import React from 'react';
import payPalLogo from '../../assets/paypal-logo-btn.svg';
import styles from './SubmitBtn.module.css';

interface PayPalButtonProps {
  handlePayPal: () => void;
  disabled: boolean;
}

const PayPalButton: React.FunctionComponent<PayPalButtonProps> = ({ handlePayPal, disabled }) => (
  <button type="button" onClick={handlePayPal} className={styles.payPal} disabled={disabled}>
    Check Out with
    <img src={payPalLogo as unknown as string} alt="Pay with PayPal" />
  </button>
);

export default PayPalButton;
